export function MouseWheelListen(element, callback, noScroll) {
  if (typeof element === "function") {
    noScroll = !!callback;
    callback = element;
    element = window;
  }
  // eslint-disable-next-line radix
  var lineHeight = parseInt(
    getComputedStyle(document.body).fontSize.replace("px", ""),
    0
  );
  var listener = (ev) => {
    if (noScroll) {
      ev.preventDefault();
    }
    var dx = ev.deltaX || 0;
    var dy = ev.deltaY || 0;
    var dz = ev.deltaZ || 0;
    var mode = ev.deltaMode;
    var scale = 1;
    switch (mode) {
      case 1:
        scale = lineHeight;
        break;
      case 2:
        scale = window.innerHeight;
        break;
      default:
    }
    dx *= scale;
    dy *= scale;
    dz *= scale;
    if (dx || dy || dz) {
      return callback(dx, dy, dz, ev);
    }
  };
  const listen = () => {
    element?.addEventListener("wheel", listener);
  };
  const unListen = () => {
    element?.removeEventListener("wheel", listener);
  };
  return { listen, unListen };
}
